import { Box, Divider } from "@mui/material";
import { memo } from "react";
import DocumentFilter from "./DocumentFilter";
import DocumentTreeView from "./DocumentTreeView";

export interface DocumentSidebarProps {
    isGraphEnabled: boolean;
    // Wenn true (z. B. GPT‑only), UI sichtbar lassen aber Interaktionen deaktivieren
    isDocumentSelectionDisabled?: boolean;
}

export const DocumentSidebar = memo(({ isGraphEnabled, isDocumentSelectionDisabled = false }: DocumentSidebarProps) => {
    return (
        // Wurzel‑Container: füllt den Flex‑Slot des Elterns; keine eigenen Scrollleisten
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
                minHeight: 0,
                minWidth: 0,
                overflow: "hidden",
            }}
        >
            {/* Dokument‑Filter – oben fixiert */}
            <Box sx={{ flexShrink: 0 }}>
                <DocumentFilter disabled={isDocumentSelectionDisabled} />
            </Box>

            {/* Dokument‑Baum – füllt den Restbereich */}
            {/* Einziger Scrollbereich in der Seitenleiste */}
            <Box
                sx={{
                    flex: '1 1 0%',
                    height: 0,
                    minHeight: 0,
                    overflow: 'auto',
                    overscrollBehavior: 'contain',
                    WebkitOverflowScrolling: 'touch',
                    opacity: isDocumentSelectionDisabled ? 0.5 : 1,
                    "& .MuiTreeItem-group": { marginLeft: 2 },
                }}
            >
                <DocumentTreeView isGraphEnabled={isGraphEnabled} isDocumentSelectionDisabled={isDocumentSelectionDisabled} />
            </Box>
        </Box>
    );
});
